import { render, staticRenderFns } from "./ActiveCashCollectionsByBranchReport.vue?vue&type=template&id=d4478354&"
import script from "./ActiveCashCollectionsByBranchReport.vue?vue&type=script&lang=js&"
export * from "./ActiveCashCollectionsByBranchReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports